import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const NcVehicleRegistrationService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}/vr-payable`;

  service.getPayablesBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(criteria);
    if (criteria.externalBillId) {
      return axios.get(`${BASE_URL}/externalBillId${queryString}`, {
        headers,
      });
    }
    if (criteria.plateNumber) {
      return axios.get(`${BASE_URL}/plateNumber${queryString}`, {
        headers,
      });
    }
    if (criteria.customerId) {
      return axios.get(`${BASE_URL}/customerId${queryString}`, {
        headers,
      });
    }
    return axios.get(`${BASE_URL}/transactionId${queryString}`, {
      headers,
    });
  };

  return service;
})();

export default NcVehicleRegistrationService;
